export default __webpack_public_path__ + "static/media/m312.ac84eecf.png";